// =============================================
// CURRENCY RATE PRELOAD (BuckSCC + free API)
// =============================================
var _bucksRateCache = {};
var _bucksRatesLoaded = false;

function getBucksCurrency() {
  var el = document.querySelector('.bucks-selected');
  if (el && el.textContent.trim()) return el.textContent.trim().toUpperCase();
  try {
    var stored = localStorage.getItem('buckscc_auto_currency');
    if (stored) {
      var parsed = JSON.parse(stored);
      if (parsed && parsed.currency) return parsed.currency.toUpperCase();
    }
  } catch(e) {}
  return 'AED';
}

function formatPrice(cents, baseCurrency) {
  var base = (baseCurrency || 'AED').toUpperCase();
  var target = getBucksCurrency();
  var amount = cents / 100;

  if (target && target !== base && _bucksRateCache[target]) {
    amount = amount * _bucksRateCache[target];
  } else if (target === base || !target) {
    // no conversion needed
  }

  try {
    return new Intl.NumberFormat(undefined, {
      style: 'currency',
      currency: target || base,
      minimumFractionDigits: 2
    }).format(amount);
  } catch(e) {
    return amount.toFixed(2) + ' ' + (target || base);
  }
}

// Preload exchange rates on page load
(function preloadRates() {
  var base = 'aed';
  var apis = [
    'https://cdn.jsdelivr.net/npm/@fawazahmed0/currency-api@latest/v1/currencies/' + base + '.json',
    'https://open.er-api.com/v6/latest/AED',
    'https://api.exchangerate-api.com/v4/latest/AED'
  ];

  function tryApi(index) {
    if (index >= apis.length) return;
    fetch(apis[index])
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var rates = data[base] || data.rates || data.conversion_rates;
        if (rates) {
          Object.keys(rates).forEach(function(k) {
            _bucksRateCache[k.toUpperCase()] = rates[k];
          });
          _bucksRatesLoaded = true;
        } else {
          tryApi(index + 1);
        }
      })
      .catch(function() { tryApi(index + 1); });
  }
  tryApi(0);
})();

document.addEventListener("DOMContentLoaded", function () {

  const drawer = document.getElementById("custom-cart-drawer2");
  const overlay = document.getElementById("drawer2-overlay");
  const closeBtn = document.getElementById("drawer2-close");

  /* =========================
     OPEN / CLOSE
  ========================= */

  function openDrawer() {
    drawer.classList.add("active");
    overlay.classList.add("active");
    loadCart();
  }

  function closeDrawer() {
    drawer.classList.remove("active");
    overlay.classList.remove("active");
  }

  /* OPEN DRAWER IF URL HAS openCart */

  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get("openCart")) { openDrawer(); }

  closeBtn?.addEventListener("click", function(e){ e.stopPropagation(); closeDrawer(); });
  overlay?.addEventListener("click", function(e){ if (e.target === overlay) { closeDrawer(); } });
  drawer?.addEventListener("click", function(e){ e.stopPropagation(); });

  /* =========================
     GLOBAL CLICK HANDLER
  ========================= */

  document.addEventListener("click", async function (e) {

    /* NORMAL PRODUCT ADD */

    const atcBtn = e.target.closest(".productitem--action-atc");

    if (atcBtn) {
      e.preventDefault();
      e.stopImmediatePropagation();
      const variantId = atcBtn.dataset.variantId;
      if (!variantId) return;
      await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ id: variantId, quantity: 1 }) });
      openDrawer();
      return;
    }

    /* UPSELL ADD */

    const upsellBtn = e.target.closest(".upsell__btn");

    if (upsellBtn) {
      e.preventDefault();
      const variantId = upsellBtn.dataset.variantId;
      if (!variantId) return;
      await fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify({ id: variantId, quantity: 1 }) });
      loadCart();
      return;
    }

    /* REMOVE ITEM */

    const removeBtn = e.target.closest(".drawer2__remove");

    if (removeBtn) {
      e.preventDefault();
      const key = removeBtn.dataset.key;
      await fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: 0 }) });
      loadCart();
      return;
    }

    /* QUANTITY + */

    const plusBtn = e.target.closest(".qty-plus");

if (plusBtn) {
  e.preventDefault();
  const key = plusBtn.dataset.key;
  const qty = parseInt(plusBtn.dataset.qty) + 1;

  // Update qty number instantly
  plusBtn.dataset.qty = qty;
  plusBtn.closest(".drawer2__qty").querySelector("span").innerText = qty;

  // Update price instantly (multiply unit price × new qty)
  const priceEl = plusBtn.closest(".drawer2__info").querySelector(".drawer2__price");
  const unitPrice = parseInt(plusBtn.dataset.unitPrice || 0);
  if (priceEl && unitPrice) priceEl.innerText = formatPrice(unitPrice * qty, plusBtn.dataset.currency || 'AED');

  fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) }).then(loadCart);
  return;
}

    /* QUANTITY - */

    const minusBtn = e.target.closest(".qty-minus");

if (minusBtn) {
  e.preventDefault();
  const key = minusBtn.dataset.key;
  const qty = parseInt(minusBtn.dataset.qty) - 1;

  // Update qty number instantly
  minusBtn.dataset.qty = qty;
  minusBtn.closest(".drawer2__qty").querySelector("span").innerText = qty;

  // Update price instantly
  const priceEl = minusBtn.closest(".drawer2__info").querySelector(".drawer2__price");
  const unitPrice = parseInt(minusBtn.dataset.unitPrice || 0);
  if (priceEl && unitPrice) priceEl.innerText = formatPrice(unitPrice * qty, minusBtn.dataset.currency || 'AED');

  fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) }).then(loadCart);
  return;
}

    /* CART ICON CLICK */

    const cartLink = e.target.closest("a[href*='/cart']");

    if (cartLink) {
      e.preventDefault();
      e.stopImmediatePropagation();
      openDrawer();
    }

  }, true);


  /* =========================
     LOAD CART CONTENT
  ========================= */

  async function loadCart() {

    const res = await fetch("/cart.js");
    const cart = await res.json();
    const itemsBox = document.getElementById("drawer2-items");
    const totalBox = document.getElementById("drawer2-total");

    if (!itemsBox || !totalBox) return;
    itemsBox.innerHTML = "";

    var currency = cart.currency || 'AED';

    if (cart.items.length === 0) {
      itemsBox.innerHTML = `<p>Your cart is empty.</p>`;
      totalBox.innerText = formatPrice(0, currency);
    } else {

      cart.items.forEach(item => {
        itemsBox.innerHTML += `
<div class="drawer2__item">
  <img class="drawer2__img" src="${item.image}" />
  <div class="drawer2__info">
    <div class="drawer2__top">
      <div class="drawer2__title">${item.product_title}</div>
      <button class="drawer2__remove" data-key="${item.key}">✕</button>
    </div>
    <div class="drawer2__price">${formatPrice(item.final_line_price, currency)}</div>
    <div class="drawer2__qty">

     <button class="qty-minus" data-key="${item.key}" data-qty="${item.quantity}" data-unit-price="${item.price}" data-currency="${currency}">−</button>
<span>${item.quantity}</span>
<button class="qty-plus" data-key="${item.key}" data-qty="${item.quantity}" data-unit-price="${item.price}" data-currency="${currency}">+</button>

    </div>
  </div>
</div>`;
      });

      totalBox.innerText = formatPrice(cart.total_price, currency);

    }

    /* =========================
       AUTO DISCOUNT BANNER
       (dynamic — fetches qualifying collections from Shopify)
    ========================= */

    const bannerEl = document.getElementById("drawer2-auto-discount");
    if (bannerEl && cart.items.length > 0) {

      const discountCollections = (bannerEl.dataset.collections || '').split('|').map(c => c.trim()).filter(Boolean);

      if (discountCollections.length === 0) {
        bannerEl.style.display = "none";
      } else {

        const colFetches = discountCollections.map(col =>
          fetch('/collections/' + col + '/products.json?limit=250')
            .then(r => r.json())
            .then(data => (data.products || []).map(p => p.id))
            .catch(() => [])
        );

        Promise.all(colFetches).then(function(results) {
          const qualifyingIds = [].concat(...results);

          const qualifyingQty = cart.items.reduce(function(sum, item) {
            return sum + (qualifyingIds.includes(item.product_id) ? item.quantity : 0);
          }, 0);

          if (qualifyingQty === 0) {
            bannerEl.style.display = "none";
          } else if (qualifyingQty >= 5) {
            bannerEl.style.display = "block";
            bannerEl.className = "drawer2__auto-discount active-discount";
            bannerEl.innerHTML = "🎉 20% discount automatically applied!";
          } else if (qualifyingQty >= 3) {
            bannerEl.style.display = "block";
            bannerEl.className = "drawer2__auto-discount active-discount";
            bannerEl.innerHTML = "🎉 15% discount applied!<br>Add " + (5 - qualifyingQty) + " more item(s) to get 20% off.";
          } else if (qualifyingQty >= 2) {
            bannerEl.style.display = "block";
            bannerEl.className = "drawer2__auto-discount active-discount";
            bannerEl.innerHTML = "🎉 10% discount applied!<br>Add " + (3 - qualifyingQty) + " more item(s) to get 15% off.";
          } else {
            bannerEl.style.display = "block";
            bannerEl.className = "drawer2__auto-discount nudge-discount";
            bannerEl.innerHTML = "💡 Add 1 more item to get 10% off!";
          }
        });
      }

    } else if (bannerEl) {
      bannerEl.style.display = "none";
    }

  } // end loadCart()

  // Expose loadCart globally so polling loop can call it
  window.loadCart = loadCart;

}); // end DOMContentLoaded


// apply coupons
// coupon functions below
// =====================
// COUPON POPUP
// =====================

function toggleCoupon(id) {
  const item = document.getElementById(id);
  if (!item || item.classList.contains('locked')) return;
  document.querySelectorAll('.coupon-item').forEach(el => el.classList.remove('selected'));
  item.classList.add('selected');
  updateMaxSavings();
}

function updateMaxSavings() {
  const selected = document.querySelector('.coupon-item.selected');
  const savingsEl = document.getElementById('couponMaxSavings');
  if (!savingsEl) return;
  if (selected) {
    const savings = selected.dataset.savings || selected.querySelector('.coupon-save-label')?.textContent?.trim() || '—';
    savingsEl.textContent = savings;
  } else {
    savingsEl.textContent = '—';
  }
}

function checkCouponCode() {
  const input = document.getElementById('couponCodeInput');
  if (!input || !input.value.trim()) return;
  const code = input.value.trim().toUpperCase();
  const match = Array.from(document.querySelectorAll('.coupon-item[data-code]'))
    .find(el => el.dataset.code.toUpperCase() === code);
  if (match) {
    document.querySelectorAll('.coupon-item').forEach(el => el.classList.remove('selected'));
    match.classList.add('selected');
    match.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    updateMaxSavings();
  } else {
    alert('Coupon code "' + code + '" is not valid.');
  }
}

function applyCoupon() {
  const selected = document.querySelector('.coupon-item.selected[data-code]');
  if (selected) {
    const code = selected.dataset.code.trim();
    const savings = selected.dataset.savings || '';

    // Update coupon row label
    const label = document.getElementById('coupon-row-label');
    if (label) { label.textContent = code + ' Applied ✓'; label.style.color = '#1c7c4c'; }

    // Update APPLY button to CHANGE
    const applyBtn = document.querySelector('.coupon-apply-btn');
    if (applyBtn) applyBtn.textContent = 'CHANGE';

    // Inject discount into checkout URL
    const checkoutBtn = document.getElementById('drawer2-checkout-btn');
    if (checkoutBtn) checkoutBtn.href = '/checkout?discount=' + encodeURIComponent(code);

    // Show estimated discount in savings banner
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var total = cart.total_price;
        var discountAmount = 0;
        var pct = savings.match(/(\d+(\.\d+)?)\s*%/);
        var flat = savings.match(/[\d,]+(\.\d+)?/);

        if (pct) {
          discountAmount = Math.round(total * parseFloat(pct[1]) / 100);
        } else if (flat && !savings.toLowerCase().includes('item') && !savings.toLowerCase().includes('free')) {
          discountAmount = parseFloat(flat[0].replace(',', '')) * 100;
        }

        var savingsBanner = document.querySelector('.drawer2__savings');
        if (savingsBanner && discountAmount > 0) {
          var formatted = Shopify.formatMoney(discountAmount);
          savingsBanner.innerHTML = 'Coupon <strong>' + code + '</strong> applied - you save ' + formatted + ' at checkout!';
          savingsBanner.style.background = '#e7f5ec';
          savingsBanner.style.color = '#1c7c4c';
        } else if (savingsBanner) {
          savingsBanner.innerHTML = '\u2713 Coupon <strong>' + code + '</strong>' + (savings ? ' (' + savings + ')' : '') + ' will be applied at checkout!';
        }
      });
  }
  closeCouponPopup();
}

function openCouponPopup() {
  document.getElementById('couponOverlay').classList.add('active');
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var totalQty = cart.items.reduce(function(sum, i) { return sum + i.quantity; }, 0);

      // Collect unique collection handles (pipe-separated)
      var allCollections = [];
      document.querySelectorAll('.coupon-item[data-required-collection]').forEach(function(el) {
        var cols = (el.dataset.requiredCollection || '').split('|').map(function(c) { return c.trim(); }).filter(Boolean);
        cols.forEach(function(col) {
          if (allCollections.indexOf(col) === -1) allCollections.push(col);
        });
      });

      if (allCollections.length === 0) {
        evaluateCoupons(cart, totalQty, {});
        return;
      }

      var collectionProductMap = {};
      var fetches = allCollections.map(function(col) {
        return fetch('/collections/' + col + '/products.json?limit=250')
          .then(function(r) { return r.json(); })
          .then(function(data) {
            collectionProductMap[col] = (data.products || []).map(function(p) { return p.id; });
          })
          .catch(function() { collectionProductMap[col] = []; });
      });
      Promise.all(fetches).then(function() {
        evaluateCoupons(cart, totalQty, collectionProductMap);
      });
    });
}

function evaluateCoupons(cart, totalQty, collectionProductMap) {
  document.querySelectorAll('.coupon-item').forEach(function(el) {
    var minItems = parseInt(el.dataset.minItems) || 1;
    var requiredCol = el.dataset.requiredCollection || '';
    var requiredProductsStr = el.dataset.requiredProducts || '';
    var note = el.querySelector('.coupon-unlock-note');
    var lockReason = '';

    if (requiredProductsStr) {
      // Check if any required product is in cart (comma-separated IDs)
      var requiredIds = requiredProductsStr.split(',').map(function(id) { return parseInt(id.trim()); }).filter(Boolean);
      var hasProduct = cart.items.some(function(item) { return requiredIds.indexOf(item.product_id) !== -1; });
      if (!hasProduct) { lockReason = 'Add a qualifying product to unlock this coupon.'; }
    } else if (requiredCol) {
      // Support pipe-separated collections
      var cols = requiredCol.split('|').map(function(c) { return c.trim(); });
      var allColIds = [];
      cols.forEach(function(c) {
        if (collectionProductMap[c]) {
          collectionProductMap[c].forEach(function(id) { if (allColIds.indexOf(id) === -1) allColIds.push(id); });
        }
      });
      var qualifyingQty = cart.items.reduce(function(sum, item) {
        return sum + (allColIds.indexOf(item.product_id) !== -1 ? item.quantity : 0);
      }, 0);
      if (qualifyingQty < minItems) { lockReason = 'Add ' + (minItems - qualifyingQty) + ' more item(s) from the required collection to unlock.'; }
    } else if (totalQty < minItems) {
      lockReason = 'Add ' + (minItems - totalQty) + ' more item(s) to unlock.';
    }

    if (lockReason) {
      el.classList.add('locked'); el.classList.remove('selected');
      if (note) { note.textContent = lockReason; note.style.display = 'block'; }
    } else {
      el.classList.remove('locked');
      if (note) note.style.display = 'none';
    }
  });

  document.querySelectorAll('.coupon-item').forEach(function(el) { el.classList.remove('selected'); });
  var first = document.querySelector('.coupon-item:not(.locked)');
  if (first) first.classList.add('selected');
  updateMaxSavings();
}

function closeCouponPopup() {
  document.getElementById('couponOverlay').classList.remove('active');
}

function handleOverlayClick(e) {
  if (e.target.id === 'couponOverlay') closeCouponPopup();
}


// =============================================
// INTERCEPT PRODUCT PAGE ADD TO CART FORM
// =============================================
document.addEventListener("DOMContentLoaded", function () {

  // Find the product form
  const productForm = document.querySelector('form[action="/cart/add"]');
  if (!productForm) return;

  productForm.addEventListener("submit", async function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();

    const variantInput = productForm.querySelector('[name="id"]');
    const quantityInput = productForm.querySelector('[name="quantity"]');
    if (!variantInput) return;

    const variantId = variantInput.value;
    const quantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    try {
      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: quantity })
      });
      if (!addRes.ok) { console.error("Add to cart failed:", addRes.status); return; }
      await addRes.json();
    } catch (err) {
      console.error("Add to cart failed:", err);
      return;
    }

    // Wait for Shopify cart state to fully update
    await new Promise(function(resolve) { setTimeout(resolve, 300); });

    const drawer = document.getElementById("custom-cart-drawer2");
    const overlay = document.getElementById("drawer2-overlay");
    if (!drawer || !overlay) return;

    drawer.classList.add("active");
    overlay.classList.add("active");

    if (typeof window.loadCart === "function") window.loadCart();

  }, true);

});


// =============================================
// DETECT CART CHANGES → Open drawer
// =============================================
(function () {
  let lastItemCount = null;

  async function checkCart() {
    try {
      const res = await fetch("/cart.js");
      const cart = await res.json();

      if (lastItemCount !== null && cart.item_count !== lastItemCount) {
        const drawer = document.getElementById("custom-cart-drawer2");
        const overlay = document.getElementById("drawer2-overlay");
        if (drawer && overlay) {
          drawer.classList.add("active");
          overlay.classList.add("active");
          // Call loadCart() so banner logic runs with collection check
          if (typeof window.loadCart === "function") window.loadCart();
        }
      }

      lastItemCount = cart.item_count;
    } catch (e) {}
  }

  checkCart();
  setInterval(checkCart, 500);
})();